import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    details: [],
    list: [],
    loading: false,
    agentBasketDetails: [],
    deviceDetails: [],
    saleAgentBasketImagesDetails: [],
  },

  getters: {
    details: (state) => state.details,
    list: (state) => state.list,
    loading: (state) => state.loading,
    agentBasketDetails: (state) => state.agentBasketDetails,
    businessToBusinessBasketDetails: (state) =>
      state.businessToBusinessBasketDetails,
    deviceDetails: (state) => state.deviceDetails,
    saleAgentBasketImagesDetails: (state) => state.saleAgentBasketImagesDetails,
  },
  actions: {
    submitDiscountApi({ commit, dispatch }, model) {
      return ajax
        .put("Sales/api/SaleAgentBasket/apply-immediate-discount", model)
        .then(() => {});
    },
    submitCommissionApi({ commit, dispatch }, model) {
      return ajax
        .put("Sales/api/Baskets/assign-commission", model)
        .then(() => {});
    },
    fetchSingle({ commit }, id) {
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/BasketsQuery/0/0/0/" + id)
          .then((r) => {
            commit("setDetails", r.data);
            commit("setLoading", false);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    fetchSaleAgentBasket({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/SaleAgentBasketsQuery/" + id)
          .then((r) => {
            commit("setAgentBasketDetails", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    fetchLatestRecords({ commit }) {
      return ajax
        .get(
          "Sales/api/BasketsQuery?take=5&skip=0&basketFlowState=1&basketState=1&SalesType=1"
        )
        .then((r) => {
          commit("setList", r.data.data);
        });
    },
    confirmBasket({ commit, dispatch }, payload) {
      return ajax
        .patch(
          "Sales/api/Baskets/" + payload.basketId + "/confirm-status",
          payload,
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {});
    },
    confirmAgentBasket({ commit, dispatch }, id) {
      return ajax
        .patch(
          "Sales/api/SaleAgentBasket/" + id + "/confirm-status",
          { basketId: id },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {});
    },
    basketDelivered({ commit, dispatch }, id) {
      return ajax
        .put(
          "Sales/api/Baskets/" + id + "/deliver-status",
          { basketId: id },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {});
    },
    rejectBasket({ commit, dispatch }, model) {
      return ajax
        .put("Sales/api/Baskets/reject-status", model, {
          headers: { "Content-Type": "application/json" },
        })
        .then(() => {});
    },
    addSaleAgentBasket({ commit, dispatch }, model) {
      return ajax.post("Sales/api/SaleAgentBasket", model).then(() => {});
    },
    closeSaleAgentBasket({ commit, dispatch }, model) {
      return ajax
        .put("Sales/api/SaleAgentBasket/close-status", model)
        .then(() => {});
    },
    openSaleAgentBasket({ commit, dispatch }, model) {
      return ajax
        .put("Sales/api/SaleAgentBasket/open-status", model)
        .then(() => {});
    },
    updateSaleAgentBasket({ commit, dispatch }, model) {
      return ajax.put("Sales/api/SaleAgentBasket", model).then(() => {});
    },
    updateSettlementDate({ commit, dispatch }, model) {
      return ajax
        .put(
          "Sales/api/SaleAgentBasket/settlement-date/from-stock-draft-order",
          model
        )
        .then(() => {});
    },
    getBasketDeviceInfo({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/BasketsQuery/" + id + "/DeviceInfo")
          .then((r) => {
            commit("setDeviceDetails", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    fetchSaleAgentBasketImages({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/SaleAgentBasketsQuery/" + id + "/documents")
          .then((r) => {
            commit("setSaleAgentBasketImages", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    saleAgentBasketAddImage({ commit, dispatch }, model) {
      return ajax
        .post("Sales/api/SaleAgentBasket/document", model)
        .then(() => {});
    },
    saleAgentBasketRemoveImage({ commit, dispatch }, { basketId, name }) {
      return ajax
        .delete(
          "Sales/api/SaleAgentBasket/document",
          { data: { basketId: basketId, name: name } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {});
    },
  },
  mutations: {
    setDetails(state, data) {
      state.details = data;
    },
    setList(state, data) {
      state.list = data;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setAgentBasketDetails(state, data) {
      state.agentBasketDetails = data;
    },
    setDeviceDetails(state, data) {
      state.deviceDetails = data;
    },
    setSaleAgentBasketImages(state, data) {
      state.saleAgentBasketImagesDetails = data;
    },
  },
};
